import { activateAttributes } from "../../../apis/activateAttributes.js";

activateAttributes();

export { setParameters as apply } from "../../../apis/setParameters.js";
